/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const transfer_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.5 15.5H23M19.5 19l3.5-3.5m0 0L19.5 12m-6-3.5H1M4.5 12 1 8.5m0 0L4.5 5"
    />
  </svg>
)
export default transfer_medium
